import './cadastro.css'
import google_logo from '../../assets/google_logo.webp'
import Icon from '@mdi/react';
import { mdiAlertCircleOutline, mdiEye, mdiEyeClosed } from '@mdi/js'
import { useEffect, useState } from 'react'
import { Link, useNavigate } from "react-router-dom";
import LoadingElement from '../components/loading_element/index.js';
import { API_BASE_URL } from '../../global.js';
import { GoogleLogin } from '@react-oauth/google';

export default function Cadastro({ isAuth, setIsAuth }) {

    const navigate = useNavigate();

    useEffect(() => {
        const auth = localStorage.getItem("auth");
        if (auth === "true") {
            navigate('/')
        }
    }, [])

    const [seePassword, setSeePassword] = useState(false);
    const [loadingCadastro, setLoadingCadastro] = useState(false);

    const [nome, setNome] = useState('');
    const [sobrenome, setSobrenome] = useState('');
    const [email, setEmail] = useState('');
    const [cpf, setCpf] = useState('');
    const [senha, setSenha] = useState('');
    const [emailPromo, setEmailPromo] = useState(false);
    const [termos, setTermos] = useState(false)

    const [erro, setErro] = useState(false);
    const [erroMsg, setErroMsg] = useState('');

    const validarEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    const validarSenha = (senha) => {
        const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,24}$/;
        return regex.test(senha);
    }

    const validarCPF = (cpf) => {

        cpf = cpf.replace(/\D/g, '');

        if (cpf.length !== 11) return false;

        // evita 00000000000, 11111111111 etc
        if (/^(\d)\1+$/.test(cpf)) return false;

        let soma = 0;
        let resto;

        for (let i = 1; i <= 9; i++)
            soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);

        resto = (soma * 10) % 11;

        if ((resto === 10) || (resto === 11))
            resto = 0;

        if (resto !== parseInt(cpf.substring(9, 10)))
            return false;

        soma = 0;

        for (let i = 1; i <= 10; i++)
            soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);

        resto = (soma * 10) % 11;

        if ((resto === 10) || (resto === 11))
            resto = 0;

        if (resto !== parseInt(cpf.substring(10, 11)))
            return false;

        return true;
    }

    const cadastrar = async () => {
        if (loadingCadastro) return;
        setLoadingCadastro(true);


        if (nome === '') {
            setErro(true);
            setErroMsg("Campo 'Nome' não pode ficar em branco");
            setLoadingCadastro(false);
            return;
        }
        if (nome.length < 3) {
            setErro(true);
            setErroMsg("Insira um nome realmente válido");
            setLoadingCadastro(false);
            return;
        }
        if (sobrenome === '') {
            setErro(true);
            setErroMsg("Campo 'Sobrenome' não pode ficar em branco");
            setLoadingCadastro(false);
            return;
        }
        if (sobrenome.length < 3) {
            setErro(true);
            setErroMsg("Insira um sobrenome realmente válido");
            setLoadingCadastro(false);
            return;
        }
        if (email === '') {
            setErro(true);
            setErroMsg("Campo 'Email' não pode ficar em branco");
            setLoadingCadastro(false);
            return;
        }
        if (!validarEmail(email)) {
            setErro(true);
            setErroMsg("Insira um e-mail realmente válido");
            setLoadingCadastro(false);
            return;
        }
        if (cpf === '') {
            setErro(true);
            setErroMsg("Campo 'CPF' não pode ficar em branco");
            setLoadingCadastro(false);
            return;
        }
        if (!validarCPF(cpf)) {
            setErro(true);
            setErroMsg("Insira um CPF realmente válido");
            setLoadingCadastro(false);
            return;
        }
        if (senha === '') {
            setErro(true);
            setErroMsg("Campo 'Senha' não pode ficar em branco");
            setLoadingCadastro(false);
            return;
        }
        if (!validarSenha(senha)) {
            setErro(true);
            setErroMsg("A senha deve ter entre 8 e 24 caracteres, incluir uma letra maiúscula, um número e um caractere especial");
            setLoadingCadastro(false);
            return;
        }
        if (!termos) {
            setErro(true);
            setErroMsg("Você precisa concordar com nossa política de privacidade para se cadastrar");
            setLoadingCadastro(false);
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/auth/cadastro.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({
                    nome: nome,
                    sobrenome: sobrenome,
                    email: email,
                    cpf: cpf,
                    senha: senha,
                    emailPromo: emailPromo
                })
            });

            const data = await response.json();
            if (data.status === 'success') {
                localStorage.setItem("auth", "true");
                localStorage.setItem("verificado", "false");
                setIsAuth(true)
                navigate('/EmailVerify');
                setLoadingCadastro(false);

            } else {
                setErro(true);
                setErroMsg(data.error);
                localStorage.setItem("auth", "false");
                setIsAuth(false);
                setLoadingCadastro(false);
            }

        } catch (error) {
            console.log('Erro de conexão:', error);
            setLoadingCadastro(false);
        }
    }


    const handleCpf = (value) => {
        const somenteNumeros = value.replace(/\D/g, '').slice(0, 11);
        setCpf(somenteNumeros);
    }

    /**GOOLE**/
    async function loginGoogle(credentialResponse) {

        try {

            const response = await fetch(`${API_BASE_URL}/auth/login-google.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    credential: credentialResponse.credential
                })
            }
            );

            const data = await response.json();

            console.log(data);

            if (data.status === 'success') {
                localStorage.setItem("auth", "true");
                localStorage.setItem("verificado", "true");
                setErro(false);
                setIsAuth(true);
                navigate('/');
                setLoadingCadastro(false);

            } else {
                localStorage.setItem("auth", "false");
                localStorage.setItem("verificado", "false");
                setIsAuth(false);
                setErro(true);
                setLoadingCadastro(false);
            }
        } catch (error) {
            console.error(error);
        }

    }

    return (
        <div className="cadastro_body">
            <div className='cadastro_box-cadastro'>
                <div className='cadastro_title'>
                    <h1>Cadastro</h1>
                    <p>Já possui uma conta? <Link to='/Autenticacao'>Clique para acessar!</Link></p>
                </div>
                {erro &&
                    <div className='error-msg' >
                        <p><Icon path={mdiAlertCircleOutline} size={0.75} />{erroMsg}</p>
                    </div>}
                <section className='group_double-cadastro'>


                    <div className='auth-input-group_default'>
                        <label for=''>Nome</label>
                        <input type='text' value={nome} onChange={(e) => setNome(e.target.value)} placeholder='Insira seu nome'></input>
                    </div>
                    <div className='auth-input-group_default'>
                        <label for=''>Sobrenome</label>
                        <input type='text' value={sobrenome} onChange={(e) => setSobrenome(e.target.value)} placeholder='Insira seu sobrenome'></input>
                    </div>
                </section>

                <section className='group_default-cadastro'>
                    <div className='auth-input-group_default'>
                        <label for=''>E-mail</label>
                        <input type='text' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Insira seu e-mail'></input>
                    </div>
                    <div className='auth-input-group_default'>
                        <label for=''>CPF</label>
                        <input type='text' value={cpf} onChange={(e) => handleCpf(e.target.value)} placeholder='Insira seu CPF'></input>
                    </div>
                    <div className='auth-input-group_default'>
                        <label for=''>Senha</label>
                        {!seePassword ? (
                            <input type='password' value={senha} onChange={(e) => setSenha(e.target.value)} placeholder='Insira sua senha'></input>
                        ) : (
                            <input type='text' value={senha} onChange={(e) => setSenha(e.target.value)} placeholder='Insira sua senha'></input>
                        )
                        }

                        {seePassword ? (
                            <button id='reveal_password' onClick={() => setSeePassword(false)}>
                                <Icon path={mdiEyeClosed} size={1} />
                            </button>
                        ) : (
                            <button id='reveal_password' onClick={() => setSeePassword(true)}>
                                <Icon path={mdiEye} size={1} />
                            </button>
                        )}

                    </div>

                    <div className='group_input-checkbox'>
                        <input type='checkbox' value={termos} onChange={(e) => setTermos(e.target.checked)}></input>
                        <label for='' >Concordo com os <a href='#'>Termos de uso</a> e <Link to='/PoliticaPrivacidade'>Políticas de Privacidade</Link></label>
                    </div>

                    <div className='group_input-checkbox'>
                        <input type='checkbox' value={emailPromo} onChange={(e) => setEmailPromo(e.target.checked)}></input>
                        <label for=''>Desejo receber notícias e informações promocionais por e-mail</label>
                    </div>

                    <button onClick={() => cadastrar()}>{!loadingCadastro ? 'Concluir' : <LoadingElement color={"#fff"} size={1}></LoadingElement>}</button>
                </section>

                <section className='divider'>
                    <span></span>
                    <p>Ou</p>
                    <span></span>
                </section>

                <GoogleLogin
                    onSuccess={loginGoogle}
                    onError={() => {
                        console.log('Erro no login Google');
                    }}
                />
            </div>
        </div>
    )
}